import { render, staticRenderFns } from "./InstructorList.vue?vue&type=template&id=54718b72&scoped=true&"
import script from "./InstructorList.vue?vue&type=script&lang=js&"
export * from "./InstructorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54718b72",
  null
  
)

export default component.exports